<template>
  <div>
    <div class="col-xs-6">
      <h3 class="title_base">{{ $t('bikeOverview.recheck.title') }}</h3>
      <ul class="register_list list_titleStyle list-unstyled mt50">
        <li :data-tit="$t('bikeOverview.recheck.userId')">{{ this.getBikeRegisterData.Email }}</li>
        <li :data-tit="$t('bikeOverview.recheck.gender')">{{ this.gender }}</li>
        <li :data-tit="$t('bikeOverview.recheck.info.age')">{{ age.Text }}</li>
      </ul>
      <div class="jumbotron register_notice mt50">
        <div class="container-fluid">
          <p class="red"><i class="icon-warning"></i> {{ $t('bikeOverview.recheck.notice') }}</p>
          <p>
            {{ $t('bikeOverview.recheck.content') }}
          </p>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn_qwicBtn" type="button" @click="funcOk">{{ $t('bikeOverview.recheck.btnOk') }}</button>
      </div>
    </div>
    <div class="register_over">
      <i class="icon-reg_bike"></i>
      <p>{{ $t('bikeOverview.recheck.tips') }}</p>
    </div>
  </div>
</template>
<script>
import ss from '@/utils/session-storage';
import { mapGetters } from 'vuex';

export default {
  name: 'RegisterRecheck',
  data () {
    return {
      ageList: [
        { No: 1, Text: '11-20' },
        { No: 2, Text: '21-30' },
        { No: 3, Text: '31-40' },
        { No: 4, Text: '41-50' },
        { No: 5, Text: '51-60' },
        { No: 6, Text: '61-70' },
        { No: 7, Text: '71-80' }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getBikeRegisterData: 'bikeConnect/getBikeRegisterData'
    }),
    age () {
      return this.ageList.find(item => {
        return item.No === this.getBikeRegisterData.AgeNo;
      });
    },
    gender () {
      return this.getBikeRegisterData.Gender === 0 ? this.$t('bikeOverview.recheck.info.male') : this.$t('bikeOverview.recheck.info.famale');
    }
  },
  methods: {
    funcOk () {
      ss.removeItem('bikeRegisterData');
      this.$router.push('/service-tools/bike-overview');
    }
  }
};
</script>
